<template>
  <label
    class="checkbox"
    :class="{'checkbox--active' : checked, 'checkbox--alert' : alert}"
  >
    <button
      @click="toggle"
      :class="`checkbox__button--${color}`"
      type="button"
    >
      <svg
        v-show="checked"
        class="check"
      >
        <use xlink:href="#icon-check-2"></use>
      </svg>
    </button>
    <div class="checkbox__slot">
      <slot />
    </div>
  </label>
</template>
<script>
export default {
  name: 'SharedCheckBox',
  props: {
    alert: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'yellow',
    },
    initialValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  created() {
    this.checked = this.initialValue
  },
  methods: {
    toggle() {
      this.checked = !this.checked;
      return this.$emit('check', this.checked);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import "../../../../../_src/sass/config/responsive";

/* Customize the label (the checkbox) */
.checkbox {
  @include font-size(16px);

  align-items: flex-start;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: flex-start;
  line-height: 1.6rem;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &.-justify-right {
    justify-content: flex-end;
  }

  &.-align-start {
    align-items: flex-start;
  }

  /* Position absolute of the box make it little bit tricky to aligh it by 2px, so make sure that the min-height is at least the height of the checkbox */

  @include teq-breakpoint($wide) {
    align-items: flex-end;
    justify-content: flex-start;
  }

  &__slot {
    /* Resize svg in the slot  */
    svg {
      height: 20px;
      margin-bottom: -1px;
      padding-right: 5px;
      width: 20px;
    }
  }

  &__button {
    /* start styled boxes */

    &--grey {
      @include shadow(inset 0 0 0 1px rgba(#cfc9c4, 1));

      background: none;
      border-radius: 2px !important;
    }

    &--yellow {
      @include shadow(inset 0 0 0 1px rgba(#cfc9c4, 1));

      background: white;

      .checkbox--active & {
        background: $orange;
      }

      .checkbox--active & {
        background: $orange;
      }

      /* end styled boxes */

      /* alert */
      .checkbox--alert & {
        @include shadow(inset 0 0 0 2px rgba(225, 0, 25, 1));
      }
    }
  }

  /* checkbox */
  button {
    align-content: center;
    align-items: center;
    border: none;
    border-radius: 2px !important;
    cursor: pointer;
    display: flex;
    height: 16px;
    justify-content: center;
    max-height: 16px;
    min-width: 16px;
    padding: 0;
  }

  button svg {
    flex: 1;
    height: 10px;
    margin-left: auto;
    padding-right: 0;
    width: 10px;
  }
}
</style>
